import {
  MemberDetailsNavigation,
  MemberDetailsOverlays,
  MemberFetchStatus,
  MemberHeader
} from '@bo-components/members';
import { Outlet, matchPath, useLocation } from 'react-router-dom';
import { useMemberDetails, useMemberDetailsContext } from '@bo-hooks/members';
import { MEMBER_DETAILS_PATH } from '@bo-constants/routes';
import { PermissionDenied } from '@bo-components/navigation/PermissionDenied';
import { memberDetailsRoute } from '@bo-components/navigation/Router';
import { useAuthorizePermissions } from '@bo-hooks/authentication/useAuthorizePermissions';
import { useMemo } from 'react';

export const MemberDetails = () => {
  const { hasValidPermission } = useAuthorizePermissions();
  const { pathname } = useLocation();
  const { context } = useMemberDetailsContext();
  const {
    isError,
    isLoading,
    memberProfile,
    onCloseOverlay,
    onShowOverlay,
    overlayActive
  } = useMemberDetails();

  const hasPermission = useMemo(() => {
    const matchingRoute = memberDetailsRoute.childRoutes?.find((route) =>
      matchPath(
        route.path ? `${MEMBER_DETAILS_PATH}/${route.path}` : '',
        pathname
      )
    );

    return hasValidPermission({ route: matchingRoute });
  }, [hasValidPermission, pathname]);

  const isMemberNotFound = !memberProfile;

  if (isError || (isLoading && isMemberNotFound) || isMemberNotFound) {
    return (
      <MemberFetchStatus
        isError={isError}
        isLoading={isLoading}
        isMemberNotFound={isMemberNotFound}
      />
    );
  }

  return (
    <>
      <div className="flex w-full flex-col py-3">
        <MemberHeader
          memberProfile={memberProfile}
          onShowModal={onShowOverlay}
        />
        <MemberDetailsNavigation />
        {hasPermission ? <Outlet context={context} /> : <PermissionDenied />}
      </div>
      <MemberDetailsOverlays
        memberProfile={memberProfile}
        onCloseOverlay={onCloseOverlay}
        overlayActive={overlayActive}
      />
    </>
  );
};
